module.exports = __webpack_public_path__ + "static/tres-logo-ec766c3a91121f710d10c9cca186576c.png";